module.exports = __webpack_public_path__ + "static/assets/7e9a8c0745b6da2a230a2a04cce8b5a6.png";